import { Controller } from "@hotwired/stimulus"

// Puts keyboard focus back in the conversation list after a page refresh morphs away the
// element that had it — which is what the spam toggle does: the thread leaves the list being
// viewed, the pane empties, and the button the user just pressed no longer exists. Without
// this, focus falls to <body> and a keyboard user is dumped at the top of the document.
//
// Only acts when focus was actually lost, so a morph that preserved it is left alone. Scroll
// is explicitly not moved: the same refresh signal fires when new mail arrives in the
// background, and yanking a reader's scroll position for that would be worse than the problem
// this solves.
export default class extends Controller {
  restore() {
    if (document.activeElement !== document.body) return

    // Falls back to the list region itself (tabindex="-1" in the shell) when the list is empty.
    const target = this.element.querySelector(".conversation-row__link") ||
                   this.element.querySelector(".app__list")
    target?.focus({ preventScroll: true })
  }
}
